export const organization = (organization) => {
	return {
		type: "ORGANIZATION",
		payload: organization,
	};
};

export const changeLocation = (location) => {
	return {
		type: "LOCATION",
		payload: location,
	};
};

export const locations = (locations) => {
	return {
		type: "LOCATION_LIST",
		payload: locations,
	};
};

export const changeZodiacSystems = (zodiacSystem) => {
	return {
		type: "ZODIAC_SYSTEM",
		payload: zodiacSystem,
	};
};

export const changeActivity = (activity) => {
	return {
		type: "ACTIVITY_LIST",
		payload: activity,
	};
};

export const changeGuestActivity = (guestActivity) => {
	return {
		type: "GUEST_ACTIVITY_LIST",
		payload: guestActivity,
	};
};

export const changeGuestStorageScheduling = (guestLockerSchedulingActivity) => {
	return {
		type: "GUEST_LOCKER_SCHEDULING_LIST",
		payload: guestLockerSchedulingActivity,
	};
};

export const changeCourier = (courier) => {
	return {
		type: "COURIER_LIST",
		payload: courier,
	};
};

export const changeScreenNotification = (screenNotification) => {
	return {
		type: "CHANGE_SCREEN_NOTIFICATION",
		payload: screenNotification,
	};
};

export const changeEmailTemplate = (emailTemplate) => {
	return {
		type: "CHANGE_EMAIL_TEMPLATE",
		payload: emailTemplate,
	};
};

export const changeAdministrationList = (administrationlist) => {
	return {
		type: "CHANGE_ADMIN_LIST",
		payload: administrationlist,
	};
};

export const changeRoleList = (rolesList) => {
	return {
		type: "CHANGE_ROLE_LIST",
		payload: rolesList,
	};
};
